<template>
  <div class="overflow-hidden">
    <div class="relative h-36 overflow-hidden bg-slate-700 sm:h-48">
      <core-image-banner-media
        :src="bannerSource"
        :alt="hasBanner ? `Profile banner for ${user.name}` : ''"
        :width="bannerImage?.width"
        :height="bannerImage?.height"
        :show-feature="hasBanner"
        :background-class="bannerBackgroundClass"
      />
    </div>

    <div class="relative px-3 pb-3 sm:px-6 sm:pb-6 lg:px-10 lg:pb-10">
      <div class="-mt-16 flex flex-col gap-2 sm:-mt-24">
        <div class="h-36 w-36 rounded-full mx-auto sm:h-52 sm:w-52">
          <user-avatar
            :user="user"
            size="md"
            :ui="avatarConfig"
          />
        </div>
        <h3 class="font-serif text-center text-3xl md:text-5xl py-1">{{user.name}}</h3>
      </div>

      <div class="bg-white/75 px-5 pt-5" v-if="user.bio">
        <core-fancy-text-display :text="user.bio" />
      </div>

      <div class="text-center" v-else-if="isCurrentUser">
        <u-divider class="my-5" />
        <p class="text-charcoal-400 text-lg mb-5">
          <template v-if="user.isOrganization">You have not yet added a description for your organization.</template>
          <template v-else>You have not yet added a bio.</template>
        </p>
        <u-button @click="editProfile({user})" class="min-w-44 justify-center">Edit Profile</u-button>
      </div>

      <div v-else class="text-center">
        <u-divider class="my-5" />
        <p class="text-charcoal-400 text-lg">This user has not yet added a bio.</p>
      </div>
    </div>
  </div>
</template>

<script setup>

  const {editProfile} = useUserActions();
  const sessionStore = useSessionStore();

  const props = defineProps({
    user: Object,
    modal: Object
  });

  const isCurrentUser = computed(() => props.user?.id === sessionStore.currentUserId);
  const bannerImage = computed(() => props.user?.banner_images?.large);
  const hasBanner = computed(() => Boolean(bannerImage.value?.url));
  const hasProfilePhoto = computed(() => Boolean(props.user?.avatarImage));
  const bannerSource = computed(() => (
    bannerImage.value?.url || props.user?.avatarImage || null
  ));
  const bannerBackgroundClass = computed(() => (
    !hasBanner.value && !hasProfilePhoto.value
      ? props.user?.profileClassName
      : null
  ));

  const avatarConfig = {
    wrapper: 'border-2 border-white shadow-xl !w-full !h-auto aspect-[1/1]',
    size: {md: '!w-full !h-auto aspect-[1/1] text-5xl'}
  };
</script>
